import { EventBus } from '@ga/utils'

export const events = new EventBus()
